import React from 'react';
import { Platform } from '../utils/platform';

interface FloatingActionBarProps {
  children: React.ReactNode;
}

const FloatingActionBar: React.FC<FloatingActionBarProps> = ({ children }) => (
  <div style={{
    position: 'fixed',
    bottom: Platform.isNative ? 'calc(env(safe-area-inset-bottom, 0px) + 70px)' : '100px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 6px',
    background: 'var(--color-bg-elevated)',
    backdropFilter: 'blur(20px) saturate(180%)',
    WebkitBackdropFilter: 'blur(20px) saturate(180%)',
    borderRadius: '20px',
    boxShadow: '0 1px 8px var(--color-shadow), 0 0 1px var(--color-shadow-sm)',
    border: '0.5px solid var(--color-border-light)',
  }}>
    {children}
  </div>
);

export default FloatingActionBar;
